module.exports = __webpack_public_path__ + "static/media/home.eeaa916c.jpg";